import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useSignOrderMutation } from 'api/generated/graphql';
import { parseOrderEntity, useError, useNotifyMessages } from 'api/helpers';
import { formatToISODate } from 'helpers';

interface SignOrderParams {
  otpCode: string;
  versionNumber: number;
  startDate?: Date;
  executionPeriodInBusinessDays?: number;
}

export const useSignOrder = () => {
  const notifyMessage = useNotifyMessages();

  const [signOrder, { loading, error: apolloError }] = useSignOrderMutation();

  const error = useError(apolloError);

  return {
    signOrder: useCallback(
      async (id: string, params: SignOrderParams) => {
        const res = await signOrder({
          variables: {
            id,
            input: {
              token: params.otpCode,
              versionNumber: params.versionNumber,
              startDate: params.startDate
                ? formatToISODate(params.startDate)
                : undefined,
              executionPeriodInBusinessDays:
                params.executionPeriodInBusinessDays,
            },
          },
        });

        if (res.data?.orderSign?.messages) {
          notifyMessage(res.data.orderSign.messages);
        }

        return res.data?.orderSign?.data
          ? parseOrderEntity(res.data.orderSign.data)
          : null;
      },
      [notifyMessage, signOrder]
    ),
    loading,
    error,
  };
};
